import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';
import cn from 'classnames';
import styles from './styles.module.scss';

const MediaFrame = ({ src, title, height, mobHeight, width }) => {
  const [frameStyles, setFrameStyles] = useState({});
  // No SSR default provided intentionally — isWide must only be read after mount
  // to avoid hydration mismatch (error #418). Always start with isClient=false.
  const [isClient, setIsClient] = useState(false);
  const isWide = useMedia('(min-width: 640px)', true);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!isClient) return;
    let iframeHeightStyles = mobHeight && !isWide ? { height: mobHeight } : {};
    iframeHeightStyles = width ? { ...iframeHeightStyles, width } : iframeHeightStyles;
    setFrameStyles(height && isWide ? { height, width } : iframeHeightStyles);
  }, [isClient, isWide, mobHeight, height, width]);

  return (
    <div className={cn(styles.iframeContainer, { [styles.reset]: height })}>
      <iframe
        className={cn(styles.iframe, { [styles.reset]: height })}
        title={title}
        src={src}
        style={frameStyles}
        allow="autoplay; fullscreen; picture-in-picture"
      />
    </div>
  );
};

MediaFrame.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  height: PropTypes.number,
  mobHeight: PropTypes.number,
  width: PropTypes.number,
  // position: PropTypes.oneOf(['left', 'right', 'center']),
};

export default MediaFrame;
